import { useEffect, useRef } from "react";

// CSS-only reveal-on-scroll hook (uses IntersectionObserver)
export const useReveal = (options = { threshold: 0.12 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      options
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
};
